import axios from 'axios'
import endpoint from './endpoint'

/**
 * API functions for Storing Setting
 */
export default {
  /**
   * Get Centre Information by type
   */
  getCentreInfo(payload) {
    return new Promise((resolve, reject) => {
      axios.
        get(endpoint.getCentreInfo, {
          params: {
            type: payload.type
          }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /**
   * Get Centre Type
   */
  getCentreType(payload) {
    return new Promise((resolve, reject) => {
      axios.
        get(endpoint.getCentreType)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
}
